export default {
  hasPassage (state) {
    return state.selectedDLCs.includes(4)
  },
  hasLandOfLions (state) {
    return state.selectedDLCs.includes(9)
  }
}
